export class CategoryDM {
  constructor({
    name = "",
    slug = "",
    description = "",
    thumbnail_img_url = "",
    type = "",
    display_img_url = "",
    is_flash_sale = "",
    sub_categories = [],
    icon = "",
  }) {
    this.name = name;
    this.slug = slug;
    this.description = description;
    this.thumbnail_img_url = thumbnail_img_url;
    this.type = type;
    this.display_img_url = display_img_url;
    this.is_flash_sale = is_flash_sale;
    this.sub_categories = sub_categories;
    this.icon = icon;
  }

  toJson() {
    return {
      name: this.name,
      slug: this.slug,
      description: this.description,
      thumbnail_img_url: this.thumbnail_img_url,
      type: this.type,
      display_img_url: this.display_img_url,
      is_flash_sale: this.is_flash_sale,
      sub_categories: this.sub_categories,
      icon: this.icon,
    };
  }

  static fromJson(json) {
    return new CategoryDM({
      name: json["name"],
      slug: json["slug"],
      description: json["description"],
      thumbnail_img_url: json["thumbnail_img_url"],
      type: json["type"],
      display_img_url: json["display_img_url"],
      is_flash_sale: json["is_flash_sale"],
      sub_categories: json["sub_categories"],
      icon: json["icon"],
    });
  }
}
